import React from 'react';

import { ReactComponent as Score1 } from '../assets/img/Score1.svg';
import { ReactComponent as Score2 } from '../assets/img/Score2.svg';
import { ReactComponent as Score3 } from '../assets/img/Score3.svg';
import { ReactComponent as Score4 } from '../assets/img/Score4.svg';
import { ReactComponent as Score5 } from '../assets/img/Score5.svg';
import { ReactComponent as Score } from '../assets/img/Score.svg';

const svgMap = {
  1: Score1,
  2: Score2,
  3: Score3,
  4: Score4,
  5: Score5
};

const colors = ['#D90D16', '#E48A37', '#F5BD00', '#80BD00', '#067F22'];

const secondary = ['#FBE7E8', '#FCF3EB', '#FEF8E5', '#F2F8E5', '#E6F2E9'];

export function createSvgComponent(level) {
  const SvgComponent = svgMap[level] || Score; // Usar Score como componente por defecto

  return () => <SvgComponent />;
}

export function getColorByNumber(number) {
  if (number >= 1 && number <= 5) {
    return colors[number - 1]; // Restar 1 porque los índices en arrays son 0-based
  }
  return ''; // Retornar una cadena vacía si el número no está en el rango
}

export function getBackgroundByNumber(number) {
  if (number >= 1 && number <= 5) {
    return secondary[number - 1]; // Restar 1 porque los índices en arrays son 0-based
  }
  return ''; // Retornar una cadena vacía si el número no está en el rango
}
